var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommonIconSnsMusicLineWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ECE0CE",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 11.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.105 9)",
    strokeWidth: 0.923
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-11 2.202 10.503)",
    cx: 2.202,
    cy: 10.503,
    rx: 1.477,
    ry: 1.108
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-16 8.848 8.472)",
    cx: 8.848,
    cy: 8.472,
    rx: 1.477,
    ry: 1.108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.883 4.934 10.16 2.58M3.61 10.168v-6.83c0-.457.279-.867.704-1.033L8.707.59a1.108 1.108 0 0 1 1.51 1.032v6.774"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconSnsMusicLineWhite);
export default __webpack_public_path__ + "static/media/common-icon-sns-music-line-white.54d7bbed1681e32a5f22832885266028.svg";
export { ForwardRef as ReactComponent };